import ApiWrapper from './api-wrapper'

let apiInstance = null

export function SetApiHeaderWithRefreshToken (token) {
  apiInstance.client.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
    'refresh_token'
  )}`
}

export function SetApiHeaderWithToken (token) {
  apiInstance.client.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
    'user_token'
  )}`
}

export default (headers, config) => {
  if (!apiInstance) {
    apiInstance = ApiWrapper(headers, (config = { timeout: 60000 }))
  }

  // ensures it is not stale
  if (!apiInstance.client.defaults.headers.common.Authorization) {
    SetApiHeaderWithToken()
  }

  return apiInstance
}



// WEBPACK FOOTER //
// ./src/api/api-rest.js